import { z } from 'zod';

import { dashboardT } from '../../../../../lib/messages';

export const channelGroupDialogSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, dashboardT('channelGroups.validation.nameRequired'))
    .max(80, dashboardT('channelGroups.validation.nameTooLong')),
});

export type ChannelGroupDialogFormValue = z.infer<typeof channelGroupDialogSchema>;
